import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useTranslation } from "../i18n";
import { CyberpassButton } from "../Input.jsx";
import { changeCurrent } from "../store/customer";
import { findCustomerById } from "../api/customer";

export default function AddCurrentBtn({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function clickHandler() {
    findCustomerById(null, `${id}`)
      .then((customer) => {
        dispatch(changeCurrent(customer));
        window.open("/dashboard/admin", "_blank");
      })
      .catch((error) => toast.error("Can't retrieve user with error", error));
  }

  return (
    <CyberpassButton
      type="button"
      style="secondary-light"
      onClick={clickHandler}
    >
      {t("common.openInEmployeePanel")}
    </CyberpassButton>
  );
}
